import React, { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./ContactForm.scss";

const ContactForm = () => {
    const form = useRef();
    const [formData, setFormData] = useState({
        name: "",
        company: "",
        email: "",
        message: ""
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("sending");

        try {
            await emailjs.sendForm(
                'service_a7a58ay', // Service ID from EmailJS
                'template_c9yphdu', // Template ID from EmailJS
                form.current,
                '9ggfmEcvz6vHGffhX' // Public key from EmailJS
            );
            setStatus("success");
            setFormData({ name: "", company: "", email: "", message: "" });
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('Error sending email:', error);
            }
            setStatus('error');
        }
    };

    return (
        <form ref={form} className="contact-form border" onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="name">
                    Full Name <FontAwesomeIcon icon={['fas', 'asterisk']} className="required-icon" />
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className="form-group">
                <label htmlFor="company">Company</label>
                <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                />
            </div>

            <div className="form-group">
                <label htmlFor="email">
                    Email Address <FontAwesomeIcon icon={['fas', 'asterisk']} className="required-icon" />
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
            </div>


            <div className="form-group">
                <label htmlFor="message">
                    Message <FontAwesomeIcon icon={['fas', 'asterisk']} className="required-icon" />
                </label>
                <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                ></textarea>
            </div>

            <button
                type="submit"
                className="btn btn-primary"
                disabled={status === "sending"}
                aria-busy={status === "sending"}
            >
                {status === "sending" ? "Sending..." : "Submit"}
            </button>

            <div
                aria-live="polite"
                aria-atomic="true"
                role="status"
                className="sr-only"
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}
            >
                {status === 'sending' && 'Sending message…'}
                {status === 'success' && 'Message sent successfully!'}
                {status === 'error' && 'Failed to send message. Please try again.'}
            </div>

            {status === "success" && (
                <p className="form-status success" role="status">Message sent successfully!</p>
            )}
            {status === "error" && (
                <p className="form-status error" role="alert">Failed to send message. Please try again.</p>
            )}
        </form>
    );
};

export default ContactForm;